var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 148,
    viewBox: "0 0 271 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 56,
    width: 84,
    height: 84,
    rx: 14,
    fill: "#F6C563"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 51,
    width: 84,
    height: 84,
    rx: 14,
    fill: "#00ACFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_808_4571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 44,
    width: 84,
    height: 84,
    rx: 14,
    fill: "url(#paint0_linear_808_4571)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 44,
    width: 84,
    height: 84,
    rx: 14,
    fill: "#353A4D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 60,
    width: 50,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 81,
    width: 50,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 102,
    width: 50,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 102,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 81,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 60,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.33 41.2549C267.029 38.3644 267.684 33.0225 264.794 29.3236C261.903 25.6246 256.561 24.9693 252.862 27.8599C249.163 30.7504 248.508 36.0923 251.399 39.7912C254.289 43.4902 259.631 44.1455 263.33 41.2549Z",
    fill: "white",
    stroke: "#00D2B7",
    strokeOpacity: 0.6,
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.077 79.1441C245.818 77.7838 246.127 75.27 244.766 73.5294C243.406 71.7887 240.892 71.4803 239.152 72.8405C237.411 74.2008 237.102 76.7146 238.463 78.4553C239.823 80.196 242.337 80.5044 244.077 79.1441Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 140C17.1944 140 21 136.194 21 131.5C21 126.806 17.1944 123 12.5 123C7.80558 123 4 126.806 4 131.5C4 136.194 7.80558 140 12.5 140Z",
    fill: "white",
    stroke: "#00D2B7",
    strokeOpacity: 0.6,
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.078 8.76655C223.818 7.40628 224.127 4.89247 222.767 3.15179C221.406 1.41111 218.892 1.10272 217.152 2.46298C215.411 3.82325 215.103 6.33707 216.463 8.07775C217.823 9.81843 220.337 10.1268 222.078 8.76655Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102C27.2091 102 29 100.209 29 98C29 95.7909 27.2091 94 25 94C22.7909 94 21 95.7909 21 98C21 100.209 22.7909 102 25 102Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61 148C63.2091 148 65 146.209 65 144C65 141.791 63.2091 140 61 140C58.7909 140 57 141.791 57 144C57 146.209 58.7909 148 61 148Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_808_4571",
    x: 78,
    y: 33,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_808_4571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_808_4571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_808_4571",
    x1: 113,
    y1: 107,
    x2: 155,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08E9DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksEmpty);
export default __webpack_public_path__ + "static/media/tasks-empty.bd2335e38d6f38b030af1869ce0303b8.svg";
export { ForwardRef as ReactComponent };